import React, { useState, useEffect, useCallback, useMemo, useRef, createElement } from "react";
import { Constants, isLotteryDrawOpen, DOG_OWNER_PREMIUM_ENABLED } from "@eagerdog/constants";
import { AxiosError } from "axios";
import moment from 'moment-timezone';
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Link, useSearchParams } from "react-router-dom";

import { helperService } from "../../services/helper.service";
//import { IEventSummary, , IUser, IShow, IShowElement, IDog, EventDto, ShowDto, IEventUKCConformationCount, IBreed } from "@eagerdog/interfaces";
import {
  IEventSummary,
  IContact,
  IUser,
  IShow,
  IShowElement,
  IDog,
  EventDto,
  ShowDto,
  IEventUKCConformationCount,
  IBreed,
  IEventMessage,
  IShowFullnessType,
  DuplicateEventDto,
  IShowCapacityMetrics,
  IEventHotel,
  IAddress,
  judgesListedOnShow,
} from "@eagerdog/interfaces";

import './Event.scss';

import date from "../../assets/icons/date.svg";
import copyIcon from "../../assets/icons/md-copy.svg";
import pawIcon from "../../assets/icons/paw.svg";

import { apiService } from "../../services";

import { toast } from "../../components/Toast/ToastManager";
import { Modal, useModal } from "../../components/Modal/Modal";
import Table, { IHeader, IRowAction, ITableDropAction } from "../../components/Table/Table";

import ShowForm from "../../components/StepForm/ShowForm/ShowForm";
import EventForm from "../../components/StepForm/EventForm/EventForm";
import Congrats from "../../components/Congrats/Congrats";
import DogPortrait from "../../components/DogPortrait/DogPortrait";
import Button from "../../components/Button/Button";
import DatePick from "../../components/DatePick/DatePick";
import UserSearch from "../../components/UserSearch/UserSearch";
import { download } from "src/components/Download/DownloadManager";
import Confirm from "src/components/Confirm/Confirm";
import EventFileUpload from "src/components/EventFileUpload/EventFileUpload";
import TabContent, { ITab, useTabContent } from "../../components/TabContent/TabContent";
import RibbonSkip from "src/components/RibbonSkip/RibbonSkip";
import Counts from "src/components/Counts/Counts";
import AKCCounts from "src/components/Counts/AKCCounts";
import JudgeBooksFilterModal from "../../components/JudgeBooksFilterModal/JudgeBooksFilterModal";
import NoseworkJudgeBooksFilterModal from "../../components/NoseworkJudgeBooksFilterModal/NoseworkJudgeBooksFilterModal";
import PrecisionCoursingJudgeBooksFilterModal from "../../components/PrecisionCoursingJudgeBooksFilterModal/PrecisionCoursingJudgeBooksFilterModal";
import HerdingScoresheetsFilterModal from "../../components/HerdingScoresheetsFilterModal/HerdingScoresheetsFilterModal";
import ArmbandFilterModal from "../../components/ArmbandFilterModal/ArmbandFilterModal";
import JudgingScheduleFieldsModal from "../../components/JudgingScheduleFieldsModal/JudgingScheduleFieldsModal";
import CatalogShowSelectModal from "../../components/CatalogShowSelectModal/CatalogShowSelectModal";
import SendMessage, { SendMessageType } from "../../components/SendMessage/SendMessage";
import Checkbox from "../../components/Checkbox/Checkbox";
import { localStorageService } from "../../services/local-storage.service";

import ManageShow, { showTypeSupportsJudgeSchedules } from "./ManageShow/ManageShow";
import JudgeScheduleBuilder from "./ManageShow/JudgeScheduleBuilder/JudgeScheduleBuilder";
import ShareModal from "../../components/ShareModal/ShareModal";
import RealtimeRunOrderTab from "./RealtimeRunOrderTab/RealtimeRunOrderTab";
import { buildActions } from "../../utils/buttonConfigs/eventButtons";
import { EventMetrics, ResultsViewer } from "./EventSummary";
import { EventMapComponent } from "./EventMapComponent";
import PublishEventModal from "../../components/PublishEventModal/PublishEventModal";
import ShowCapacityRow from "../../components/ShowCapacityRow/ShowCapacityRow";
import ShowElementsRow from "../../components/ShowElementsRow/ShowElementsRow";
import HotelsTab from "./HotelsTab/HotelsTab";
import DocumentsTab from "./DocumentsTab/DocumentsTab";

interface IProps {
  eid?: string
}

interface IShowTable {
  id: string,
  showType: string,
  showName: JSX.Element,
  date: JSX.Element,
  judge: string,
  price: JSX.Element | string,
  actions?: IRowAction[]
}

interface IExpectedTitleTable {
  breed: string,
  counts: string
}

const Event: React.FC<IProps> = (props) => {
  const user:IUser = helperService.getUser();
  const navigate = useNavigate();
  const location = useLocation();
  let { eid } = useParams();

  const [searchParams, setSearchParams] = useSearchParams();

  const { isShown, toggle } = useModal();
  const [loading, setLoading] = useState<boolean>(false);

  const [showMore, setShowMore] = useState<boolean>(false);
  const [showArmbandMenu, setShowArmbandMenu] = useState<boolean>(false);

  const [event, setEvent] = useState<IEventSummary>();
  const [hotels, setHotels] = useState<IEventHotel[]>([]);
  const [fullnessShows, setFullnessShows] = useState<IShowFullnessType[]>([]);

  const [tableShows, setTableShows] = useState<IShowTable[]>([]);
  const [shows, setShows] = useState<IShow[]>();
  const [showCapacityMetrics, setShowCapacityMetrics] = useState<IShowCapacityMetrics[]>([]);
  const [toggleRow, setToggleRow] = useState<number>(-1);
  const [toggleIcon, setToggleIcon] = useState<number>(-1);

  const [showTypes, setShowTypes] = useState<string[]>([]);
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const [isVolunteer, setIsVolunteer] = useState<boolean>(false);
  const [volunteerEarlyRegAllowed, setVolunteerEarlyRegAllowed] = useState<boolean>(false);
  const [eventFormInitialTab, setEventFormInitialTab] = useState<number | undefined>(undefined);


  const [lotteryShuffleLoading, setLotteryShuffleLoading] = useState<boolean>(false);
  const [waitlistedDeclineHandled, setWaitlistedDeclineHandled] = useState<boolean>(false);

  const [secretary, setSecretary] = useState<IContact>();
  const [chairperson, setChairperson] = useState<IContact>();

  const [modalContent, setModalContent] = useState<string>("");
  const [pendingModal, setPendingModal] = useState<{content: string; show?: IShow; tab?: string} | null>(null);
  const [optInToClubComms, setOptInToClubComms] = useState<boolean>(false);

  const eventKey = event?.handle ?? props.eid ?? eid;
  const shareEventUrl = eventKey
    ? `${window.location.origin}/e/${eventKey}`
    : window.location.origin;

  // Helper function to construct manage URL with admin context
  const getManageUrl = useCallback(() => {
    const adminParam = searchParams.get('admin');
    const baseUrl = eventKey ? `/e/${eventKey}/manage` : "/e/manage";
    return adminParam ? `${baseUrl}?admin=${adminParam}` : baseUrl;
  }, [searchParams, eventKey]);

  // Single-line address for the location card, e.g. "123 Main St, Springfield, IL, 62704".
  const getEventAddressLine = useCallback(() => {
    if (!event?.address) return "";
    const { line1, line2, city, state, postal_code } = event.address;
    return [line1, line2, city && state ? `${city}, ${state}` : (city || state), postal_code]
      .filter(Boolean)
      .join(", ");
  }, [event?.address]);

  const getOpenInMapsUrl = useCallback(() => {
    const addressLine = helperService.formatAddress(event?.address ?? {} as IAddress);
    const query = (addressLine || getEventAddressLine()).trim();
    if (!query) return undefined;
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
  }, [event?.address, getEventAddressLine]);

  const [registeredDogs, setRegisteredDogs] = useState<IDog[]>([]);
  const [editShow, setEditShow] = useState<IShow>();

  const [showToArchive, setShowToArchive] = useState<IShow>();

  const [showResetArmbandConfirm, setShowResetArmbandConfirm] = useState<boolean>(false);
  const [showGenerateArmbandConfirm, setShowGenerateArmbandConfirm] = useState<boolean>(false);
  const [showRunLotteryConfirm, setShowRunLotteryConfirm] = useState<boolean>(false);

  const { isShown: isDeleteShown, toggle: toggleDelete } = useModal();

  const [manageShow, setManageShow] = useState<IShow>();
  const [manageShowInitialTab, setManageShowInitialTab] = useState<string | undefined>();
  const [scheduleBuilderShow, setScheduleBuilderShow] = useState<IShow>();

  // When the shows list refreshes (e.g. after Edit Show saves), keep manageShow in sync
  // so the open ManageShow modal receives updated ring/judge data without a full reload.
  useEffect(() => {
    if (!manageShow || !shows) return;
    const refreshed = shows.find((s: IShow) => String(s._id) === String(manageShow._id));
    if (refreshed && JSON.stringify(refreshed.rings) !== JSON.stringify(manageShow.rings)) {
      setManageShow(refreshed);
    }
  }, [shows]); // eslint-disable-line react-hooks/exhaustive-deps

  const [DLShow, setDLShow] = useState<string>();

  const [duplicateStartDate, setDuplicateStartDate] = useState<Date>(new Date());
  const hasShownDuplicateModal = useRef(false);

  const [showCounts, setShowCounts] = useState<IEventUKCConformationCount[] | any[]>([]);
  const [showVariationCounts, setShowVariationCounts] = useState<any[]>([]);
  const [showExpectedTitles, setShowExpectedTitles] = useState<IExpectedTitleTable[]>([]);

  // Event summary state (for past events viewed by dog owners)
  const [eventMetrics, setEventMetrics] = useState<{ dogs: number; entries: number; distinctBreeds: number } | null>(null);

  // Judge Books Filter Modal state
  const [currentShowForJudgeBooks, setCurrentShowForJudgeBooks] = useState<IShow | null>(null);
  const [breeds, setBreeds] = useState<IBreed[]>([]);

  // Armband Filter Modal state
  const [selectedArmbandType, setSelectedArmbandType] = useState<string>("");

  // Email Show Registrants Modal state
  const [currentShowForEmailRegistrants, setCurrentShowForEmailRegistrants] = useState<IShow | null>(null);
  const [isEmailingShowRegistrants, setIsEmailingShowRegistrants] = useState<boolean>(false);
  const [isShowingEmailConfirmation, setIsShowingEmailConfirmation] = useState<boolean>(false);



  const [tabs, setTabs] = useState<ITab[]>([
    { name: "Show Schedule", actions: [] }
  ]);

  // Determine if event is past and should show summary (for dog owners)
  const isPastEvent = useMemo(() => {
    if (!event) return false;
    return moment().isAfter(moment(event.end_date).endOf('day'));
  }, [event]);

  const showEventSummary = useMemo(() => {
    if (!event) return false;
    const hasAdminAccess = (user && event.created_by === user._id) || helperService.hasAdmin(event.club_id);
    // Only show summary for dog owners with past results access who DON'T have admin access
    return isPastEvent && user.user_type === Constants.user_type.owner && (!DOG_OWNER_PREMIUM_ENABLED || user.has_past_results_access === true) && !hasAdminAccess;
  }, [isPastEvent, user, event]);

  // Reset duplicate start date when modal opens
  useEffect(() => {
    if (modalContent === "duplicateModal") {
      setDuplicateStartDate(new Date());
    }
  }, [modalContent]);

  // Show success modal if we just duplicated an event
  useEffect(() => {
    const showSuccess = location.state?.showDuplicateSuccess;
    if (showSuccess && event && !hasShownDuplicateModal.current && !isShown && modalContent === "") {
      hasShownDuplicateModal.current = true;
      
      // Clear the navigation state immediately
      window.history.replaceState({}, document.title, location.pathname);
      
      // Set modal content - the other useEffect will automatically toggle
      setModalContent("duplicateSuccess");
    }
  }, [location.state?.showDuplicateSuccess, event, location.pathname, isShown, modalContent]);

  // Reload event data when pathname changes (for navigation to duplicated event)
  useEffect(() => {
    if (eid) {
      hasShownDuplicateModal.current = false; // Reset for new event
      getEvent();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eid]); // Re-run when eid changes

  // Fetched separately (rather than as part of the event summary) so the
  // location map can plot hotel pins alongside the event pin.
  useEffect(() => {
    if (event?._id) {
      apiService.getEventHotels(event._id).then((response) => {
        setHotels(response);
      }).catch(() => {
        // Non-critical — the map just falls back to showing only the event pin.
      });
    }
  }, [event?._id]);

  // Check if user is trying to view past event without permission
  useEffect(() => {
    // Only check after event has loaded
    if (!event) return;
    
    // Check admin status directly instead of relying on isAdmin state
    const hasAdminAccess = (user && event.created_by === user._id) || helperService.hasAdmin(event.club_id);
    
    // Past results are free for everyone while Dog Owner Premium is retired.
    if (DOG_OWNER_PREMIUM_ENABLED && isPastEvent && user.user_type === Constants.user_type.owner && !user.has_past_results_access && !hasAdminAccess) {
      toast.show({
        title: "Access Restricted",
        content: "You don't have permission to view past event results. Upgrade your account to access this feature.",
        duration: 8000,
        type: "error"
      });
      // Redirect immediately
      navigate('/');
    }
  }, [isPastEvent, user, event, navigate]);

  // Determine if Real-time Run Order tab should be shown
  const shouldShowRealtimeRunOrder = useMemo(() => {
    if (!event || !shows) {
      return false;
    }
    
    // Must be logged in to see Real-time Run Order
    if (!user || !user._id || !helperService.isLoggedIn()) {
      return false;
    }
    
    // Check if event is within the active window (7 days before start until end date)
    const daysUntilEvent = moment(event.start_date).diff(moment(), 'days');
    const eventStarted = daysUntilEvent <= 7;
    const eventEnded = moment().isAfter(moment(event.end_date).endOf('day'));
    
    if (!eventStarted || eventEnded) return false;
    
    // Check if any show has run order enabled and supports judge schedules
    const runorderSupportedShowTypes = [
      Constants.show_type.obedience,
      Constants.show_type.rally_obedience, 
      Constants.show_type.scentwork,
      Constants.show_type.conformation,
      Constants.show_type.nosework,
      Constants.show_type.water_dog,
      Constants.show_type.country_rat_race,
      Constants.show_type.fast_cat,
      Constants.show_type.fetch,
      Constants.show_type.barn_hunt,
      Constants.show_type.shed_dog,
      Constants.show_type.precision_coursing
    ];
    
    const hasRealtimeShows = shows.some(show => 
      show.show_run_order === true && 
      runorderSupportedShowTypes.includes(show.show_type) &&
      show.rings && show.rings.length > 0
    );
    
    return hasRealtimeShows;
  }, [event, shows, user]);

  const [scheduleHeaders, setScheduleHeaders] = useState<IHeader[]>([
    { label: "Show Type", id: "showType" },
    { label: "Show Type", id: "showName" },
    { label: "Date", id: "date" },
    { label: "Judge", id: "judge" },
    { label: "Price (USD)", id: "price" }
  ]);

  const getJudgeNames = (show: IShow) => {
    const names = judgesListedOnShow(show).map((judge) => judge.judge_name);
    return names.length > 0 ? names.join(", ") : "Not Available";
  }

  const setShowActions = useCallback((show: IShowTable, event: IEventSummary | undefined, showInfo: IShow, adminOverride?: boolean) => {
    // Keep JSX cell values intact (JSON cloning turns React elements into plain objects)
    let _show: IShowTable = { ...show };
    
    // Use adminOverride if provided, otherwise fall back to isAdmin state
    const shouldShowActions = adminOverride !== undefined ? adminOverride : isAdmin;

    if (shouldShowActions && event !== undefined) {
      _show.actions = [
        {
          icon: "download",
          options: buildActions({ isAdmin: shouldShowActions, event, showInfo, setDLShow, setModalContent })
        },         {
          icon: "more",
          options: [
            {
              label: "Edit",
              onClick: () => {
                const scrollY = window.scrollY || window.pageYOffset;
                sessionStorage.setItem('eventPageScrollPosition', scrollY.toString());
                setEditShow(showInfo);
                setModalContent("showForm");
              }
            },
            {
              label: "Manage",
              onClick: () => {
                const scrollY = window.scrollY || window.pageYOffset;
                sessionStorage.setItem('eventPageScrollPosition', scrollY.toString());
                setManageShow(showInfo);
                setModalContent("manageShowModal");
              }
            },
            {
              label: "Email Registrants",
              onClick: () => {
                const scrollY = window.scrollY || window.pageYOffset;
                sessionStorage.setItem('eventPageScrollPosition', scrollY.toString());
                setCurrentShowForEmailRegistrants(showInfo);
                setModalContent("emailShowRegistrantsModal");
              }
            },
            {
              label: "Delete",
              onClick: () => {
                const scrollY = window.scrollY || window.pageYOffset;
                sessionStorage.setItem('eventPageScrollPosition', scrollY.toString());
                setShowToArchive(showInfo);
                setModalContent("archiveShowModal");
              }
            }
          ]
        }
      ];
      const moreActions = _show.actions?.[1]?.options;
      if (!moreActions) {
        return _show;
      }

      if (showInfo.show_type === Constants.show_type.fast_cat && event && event.sanctioning_club === Constants.sanctioning_club.AKC) {
        moreActions.push({
          label: "Show Expected Titles",
          onClick: () => {
            const scrollY = window.scrollY || window.pageYOffset;
            sessionStorage.setItem('eventPageScrollPosition', scrollY.toString());
            if (event) {
              apiService.getFastCATTitleCounts(event._id, showInfo._id).then((response: { title: string; count: number }[]) => {
                const titleDescriptions: { [key: string]: string } = {
                  'FCAT': 'FCAT',
                  'DCAT': 'DCAT',
                  'BCAT': 'BCAT'
                };

                const titleCounts = response.map(t => ({
                  breed: titleDescriptions[t.title] || t.title,
                  counts: t.count.toString()
                }));

                setShowExpectedTitles(titleCounts);
                setModalContent("showFastCATTitles");

              }).catch((e) => {
                toast.show({
                  title: "Couldn't retrieve title counts",
                  content: e.message,
                  duration: 10000,
                  type: "fail"
                });
              });
            }
          }
        });
      }

      if (event && (event.sanctioning_club === Constants.sanctioning_club.UKC || event.sanctioning_club === Constants.sanctioning_club.AKC)  && ((showInfo.show_type === Constants.show_type.conformation))) {
        moreActions.push({
          label: "Show Counts",
          onClick: () => {
            const scrollY = window.scrollY || window.pageYOffset;
            sessionStorage.setItem('eventPageScrollPosition', scrollY.toString());

            if (event) {
              // Route to correct API based on sanctioning club
              if (event.sanctioning_club === Constants.sanctioning_club.AKC) {
                // Determine if specialty show
                const isSpecialtyShow = showInfo.specialty_breed && showInfo.specialty_breed.trim() !== "";
                
                if (isSpecialtyShow) {
                  apiService.getAKCConformationSpecialtyCounts(event._id, showInfo._id).then((response) => {
                    // Response is {counts, variationCounts} for specialty shows
                    const counts = response?.counts || response;
                    const variationCounts = response?.variationCounts || [];
                    setShowCounts(counts);
                    setShowVariationCounts(variationCounts);
                    setModalContent("showCountsAKC");
                  }).catch((e) => {
                    toast.show({
                      title: "Couldn't retrieve counts",
                      content: e.message,
                      duration: 10000,
                      type: "fail"
                    });
                  });
                } else {
                  apiService.getAKCConformationCounts(event._id, showInfo._id).then((response) => {
                    setShowCounts(response);
                    setModalContent("showCountsAKC");
                  }).catch((e) => {
                    toast.show({
                      title: "Couldn't retrieve counts",
                      content: e.message,
                      duration: 10000,
                      type: "fail"
                    });
                  });
                }
              } else {
                // UKC logic (keep existing)
                apiService.getUKCConformationCounts(event._id, showInfo._id).then((response : IEventUKCConformationCount[]) => {
                  setShowCounts(response);
                  setModalContent("showCounts");
                }).catch((e) => {
                  toast.show({
                    title: "Couldn't retrieve counts",
                    content: e.message,
                    duration: 10000,
                    type: "fail"
                  });
                });
              }
            }

          }
        });
      }

      if (showInfo.show_type === Constants.show_type.nosework || showInfo.show_type === Constants.show_type.scentwork) {
        moreActions.push({
          label: "Enter Results",
          onClick: () => {
            navigate("/e/" + (eid !== undefined ? eid : props.eid) + "/manage?show=" + _show.showName.props.children[0].props.children);
          }
        });
      }
    }

    return _show;
  }, [eid, isAdmin, navigate, props.eid]);

  const formatShowPrices = (show: IShow, formatter: Intl.NumberFormat) => {
    const { format } = formatter;
    const earlyBirdActual = show.use_early_bird_fee &&
      moment(show.early_bird_end_date).isAfter(new Date(), 'minutes');

    if (show.use_same_fee && !earlyBirdActual) {
      return format(show.fee);
    }

    if (show.use_same_fee && earlyBirdActual) {
      return show.early_bird_fee ? format(show.early_bird_fee) + " (Early Bird)" : format(show.fee);
    }

    if (!show.use_same_fee) {
      const elementFees = show.show_elements.flatMap((showElement) => {
        // Total Dog and Total Junior levels are always $0 in UKC Conformation — exclude from price range
        if (showElement.level === Constants.dog_class_element_level.total_dog ||
            showElement.level === Constants.dog_class_element_level.total_junior) {
          return [];
        }
        return earlyBirdActual ? [showElement.fee, showElement.early_bird_fee] : [showElement.fee];
      }).filter((fee) => typeof fee === "number" && isFinite(fee)) as number[];
      const minFee = Math.min(...elementFees);
      const maxFee = Math.max(...elementFees);

      return `${[format(minFee), format(maxFee)].join(' - ')}${earlyBirdActual ? ' (Early Bird)' : ''}`;
    }

    return '-';
  }

  const getFullnessForShows = useCallback((id: string) => {
    apiService.getFullnessEvents([id]).then((response) => {
      if (response.length > 0) {
        setFullnessShows([...fullnessShows, ...response[0].fullness_shows])
      }
    }).catch((e: AxiosError) => {
      toast.show({
        title: "Get Shows",
        content: "Unable to get shows",
        duration: 10000,
        errorDetails: e,
        type: "fail"
      });
    }).finally(() => {
      setLoading(false)
    });
  }, [fullnessShows])

  const getEvent = useCallback((preserveScroll = false) => {
    let _eid:string|undefined = eid ? eid : props.eid;

    if (_eid) {
      // Only scroll to top on initial load, not on updates
      if (!preserveScroll && !event) {
        window.scrollTo(0, 0);
      }
      
      apiService.getEventSummaryForHandle(_eid).then((response) => {
        setEvent(response);
        localStorageService.addRecentActivity({
          type: "event",
          id: response._id,
          name: response.title,
          link: `/e/${response.handle}`,
          logo_url: response.club?.logo_url,
        });

        if (response.currency) {
          let _scheduleHeaders = JSON.parse(JSON.stringify(scheduleHeaders));

          for (let s in _scheduleHeaders) {
            if (_scheduleHeaders[s].id === "price") {
              _scheduleHeaders[s].label = "Price (" + response.currency?.toUpperCase() + ")";
              break;
            }
          }

          setScheduleHeaders(_scheduleHeaders);
        }

        for (let c in response.contacts) {
          if (response.contacts[c].contact_type === "secretary") {
            setSecretary(response.contacts[c]);
          }

          if (response.contacts[c].contact_type === "chairperson") {
            setChairperson(response.contacts[c]);
          }
        }

        const queryParameters = new URLSearchParams(window.location.search);
        const dIds = queryParameters.get("dids");

        if (dIds) {
          apiService.getUserDogs(user._id).then((dogs) => {
            let _dogs = dogs.filter((d: IDog) => dIds.split(",").includes(d._id));
            setRegisteredDogs(_dogs);

            //window.history.pushState("", "", "/e/" + _eid);
          });
        } else {
          if (user.user_type === "owner" && helperService.isLoggedIn()) {
            apiService.getRegisteredDogsByCurrentUser(response._id).then((dogsResponse) => {
              setRegisteredDogs(dogsResponse);
            });
          }
        }

        if (response.club_id && response._id) {
          apiService.getClubEventShows(response.club_id, response._id, {
            sort: [{
              attribute_name: "show_type",
              sort: "asc"
            }, {
              attribute_name: "show_date",
              sort: "asc"
            }]
          }).then(async (eventResponse: any[]) => {
            let _showTypes:string[] = [];

            if (eventResponse) {
              // Calculate admin status FIRST as a local variable (before state update)
              const userIsAdmin = (user && response.created_by === user._id) || (helperService.hasAdmin(response.club_id));
              
              if (userIsAdmin) {
                setIsAdmin(true);

                setTabs([
                  { name: "Show Schedule", actions: [ { 
                    label: "Create a Show", 
                    onClick: () => { 
                      // Preserve scroll position before opening modal
                      const scrollY = window.scrollY || window.pageYOffset;
                      sessionStorage.setItem('eventPageScrollPosition', scrollY.toString());
                      setEditShow(undefined); 
                      setModalContent("showForm"); 
                    } 
                  } ] }
                ]);
                
                const s = queryParameters.get("s");

                if (s) {
                  setModalContent("showForm");
                  window.history.pushState("", "", "/e/" + _eid);
                }
              } else if (helperService.isLoggedIn()) {
                // Check if user is a volunteer and load volunteer settings
                if (response.club?._id) {
                  try {
                    const volunteerCheck = await apiService.checkIfUserIsVolunteerForClub(response.club._id);
                    setIsVolunteer(volunteerCheck.isVolunteer);
                    
                    if (volunteerCheck.isVolunteer) {
                      const volunteerSettings = await apiService.getClubVolunteerSettings(response.club._id);
                      setVolunteerEarlyRegAllowed(volunteerSettings?.allow_early_registration || false);
                    }
                  } catch (error) {
                    console.error('Error checking volunteer status:', error);
                  }
                }
              }

              let _shows:IShowTable[] = [];

              for(let s in eventResponse) {
                if (!_showTypes.includes(eventResponse[s].show_type)) {
                  _showTypes.push(eventResponse[s].show_type);
                }

                const formatter = new Intl.NumberFormat('en-US', {
                  style: 'currency',
                  currency: event?.currency === "cad" ? "USD" : event?.currency?.toUpperCase() || "USD",
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                });

                const timeZoneString = response.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;

                let _show:IShowTable = {
                  id: eventResponse[s]._id,
                  showType: eventResponse[s].show_type,
                  showName: (() => {
                    const sh = eventResponse[s];
                    const isAKC = response.sanctioning_club === Constants.sanctioning_club.AKC;
                    const funMatchSuffix = sh.is_fun_match ? " (Fun Match)" : "";
                    if (isAKC && sh.custom_show_name) {
                      // With custom name: custom name on top, "Type - Event#: xxx" below
                      const sub = sh.event_number ? `${sh.show_type} - Event #: ${sh.event_number}` : sh.show_type;
                      return <div className="showNameInner"><span>{sh.custom_show_name}{funMatchSuffix}</span><span>{sub}</span></div>;
                    }
                    // No custom name: show_type on top, event # or show_name below
                    return <div className="showNameInner"><span>{sh.show_type}{funMatchSuffix}</span><span>{isAKC && sh.event_number ? `Event #: ${sh.event_number}` : sh.show_name}</span></div>;
                  })(),
                  //date: eventResponse[s].trailing_show ? "Follows " + (eventResponse[s].previous_show_name || " Previous Show/Trail") : moment(eventResponse[s].show_date).tz(timeZoneString).format("MMM Do YYYY, h:mmA zz"),
                  date: <div className="dateInner"><span>{eventResponse[s].trailing_show ? moment(eventResponse[s].show_date).tz(timeZoneString).format("dddd") : moment(eventResponse[s].show_date).tz(timeZoneString).format("dddd A")}</span><span>{eventResponse[s].trailing_show ? moment(eventResponse[s].show_date).tz(timeZoneString).format("MMM Do") + " - Follows " + (eventResponse[s].previous_show_name || " Previous Show/Trail")  : moment(eventResponse[s].show_date).tz(timeZoneString).format("MMM Do @ h:mm zz")}</span></div>,
                  judge: getJudgeNames(eventResponse[s]),
                  price: eventResponse[s].use_registration_end_date && eventResponse[s].registration_end_date ? 
                    <div className="priceInner">
                      <span>{formatShowPrices(eventResponse[s], formatter)}</span>
                      {eventResponse[s].use_early_bird_fee && eventResponse[s].early_bird_end_date && (
                        <span className="priceMeta">Early Bird Ends: {moment(eventResponse[s].early_bird_end_date).tz(timeZoneString).format("MMM Do @ h:mmA zz")}</span>
                      )}
                      <span className="priceMeta">Closes: {moment(eventResponse[s].registration_end_date).tz(timeZoneString).format("MMM Do @ h:mmA zz")}</span>
                    </div> :
                    formatShowPrices(eventResponse[s], formatter)
                };

                // Use the local userIsAdmin variable and response instead of state
                if (userIsAdmin) {
                  _show = setShowActions(_show, response, eventResponse[s], userIsAdmin);
                }

                _shows.push(_show);
              }

              setShows(eventResponse);
              setTableShows(_shows);
              
              // Fetch capacity metrics for all shows
              if (response._id) {
                apiService.getShowCapacityMetrics(response._id)
                  .then(setShowCapacityMetrics)
                  .catch((error) => {
                    console.error('Failed to load show capacity metrics:', error);
                  });
              }
            }

            setShowTypes(_showTypes);
          }).catch((e: AxiosError) => {
            toast.show({
              title: "Event Shows",
              content: "Unable to get event shows",
              errorDetails: e,
              duration: 10000,
              type: "fail"
            });
          }).finally(() => {
            if (user?.user_type !== "club_manager") {
              getFullnessForShows(response._id)
            } else {
              setLoading(false)
            }
          });
        }
      }).catch((e) => {
        if (e?.response?.status === 404) {
          navigate("/not-found");
        }
      });

      
    }
  }, [eid, props.eid, navigate, setIsAdmin, scheduleHeaders, setShowActions, getFullnessForShows, user]);

  // Update tabs when shouldShowRealtimeRunOrder changes
  useEffect(() => {
    if (event && shows) {
      // "Create a Show" now lives in the tab content area (like Add Hotel/Add
      // Document) instead of the tab bar, so it doesn't crowd the tabs on mobile.
      const updatedTabs = [{ name: "Show Schedule", actions: [] }];
      
      // Add Real-time Run Order tab if conditions are met
      if (shouldShowRealtimeRunOrder) {
        updatedTabs.push({ name: "Run Order", actions: [] });
      }

      updatedTabs.push({ name: "Hotels", actions: [] });
      updatedTabs.push({ name: "Documents", actions: [] });

      setTabs(updatedTabs);
    }
  }, [shouldShowRealtimeRunOrder, event, shows, isAdmin]);

  // Load event metrics for past events (dog owners)
  useEffect(() => {
    if (showEventSummary && event) {
      apiService.getEventMetricsPublic(event._id).then((metrics) => {
        setEventMetrics(metrics);
      }).catch((error) => {
        console.error('Failed to load event metrics:', error);
      });
    }
  }, [showEventSummary, event]);

  const getModalContent = () => {
        const queryParameters = new URLSearchParams(window.location.search);
        const behalf = queryParameters.get("behalf");
        const waitlist = queryParameters.get("waitlist");
        const payClubDirectly = queryParameters.get("pay_club_directly");
        const isLotteryRedirect = queryParameters.get("lottery") === "true";
        const chargedAmount = Number(queryParameters.get("charged"));
        const pointsRemaining = queryParameters.get("points_remaining");
        const pointsUsedRaw = queryParameters.get("points_used");
        const chargeCurrency = (queryParameters.get("charge_currency") || "USD").toUpperCase();
        const currencyCode = /^[A-Z]{3}$/.test(chargeCurrency) ? chargeCurrency : "USD";
        const totalCharged = queryParameters.has("charged") && !isNaN(chargedAmount)
          ? new Intl.NumberFormat("en-US", { style: "currency", currency: currencyCode, minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(chargedAmount)
          : undefined;
        const pointsUsed = pointsUsedRaw !== null && pointsUsedRaw !== "" && !isNaN(Number(pointsUsedRaw))
          ? Number(pointsUsedRaw).toLocaleString("en-US")
          : undefined;
        const remainingPoints = pointsRemaining !== null && pointsRemaining !== "" && !isNaN(Number(pointsRemaining))
          ? Number(pointsRemaining).toLocaleString("en-US")
          : undefined;

        switch (modalContent) {
      case "manageShowModal":
        return <ManageShow event={event!} show={manageShow!} onUpdate={() => { getEvent(true); }} initialTab={manageShowInitialTab} />
      case "showCounts":
        return <Counts onClose={() => { toggle(); }} tableCounts={showCounts} />;
      case "showCountsAKC":
        // Find the current show to get specialty breed info
        const currentShow = shows?.find(s => showCounts.length > 0);
        const isSpecialty = !!(currentShow?.specialty_breed && currentShow.specialty_breed.trim() !== "");
        return <AKCCounts
          onClose={() => { toggle(); }}
          tableCounts={showCounts}
          variationCounts={showVariationCounts}
          isSpecialtyShow={isSpecialty}
          specialtyBreed={currentShow?.specialty_breed}
        />;
      case "showFastCATTitles":
        return (
          <div className="Counts">
            <div className="title">Expected Titles</div>
            <p>Below are the expected title counts for this FastCAT trial based on dogs planning to earn titles.</p>
            <Table 
              headers={[
                { label: "Title Type", id: "breed" },
                { label: "Count", id: "counts" }
              ]}
              data={showExpectedTitles} 
              emptyMsg={
                <div className="emptyTable">
                  <span>No dogs are planning to earn titles in this trial.</span>
                </div>
              }
            />  
            <div className="button-group">
              <Button onClick={() => { toggle(); }}>Close</Button>
            </div>
          </div>
        );
      case "eventForm":
        return <EventForm
          key={event?._id}
          user={user}
          event={event} 
          initialTab={eventFormInitialTab}
          onFinish={() => {
            toggle();
            getEvent();
            setEventFormInitialTab(undefined); // Reset after closing

            toast.show({
              title: "Update Event",
              content: "You've successfully updated your event",
              duration: 10000,
              type: "success"
            });
          }}
        />;
      case "duplicateModal":
        return (
          <div className="DuplicateEventModal">
            <div className="title">Duplicate Event</div>
            <div className="content">
              <p>
                Choose the start date for the new event. All shows will be duplicated 
                with the same day offset from the original event "{event?.title}".
              </p>
              
              <DatePick
                label="New Event Start Date"
                value={duplicateStartDate}
                onChange={(date: Date) => {
                  setDuplicateStartDate(date || new Date());
                }}
              />
            </div>
            <div className="actions">
              <Button onClick={toggle} variant="tertiary">
                Cancel
              </Button>
              <Button
                onClick={async () => {
                  try {
                    setLoading(true);
                    
                    // Validate date before submitting
                    if (!duplicateStartDate || isNaN(duplicateStartDate.getTime())) {
                      setLoading(false);
                      toast.show({
                        title: "Invalid Date",
                        content: "Please select a valid start date",
                        duration: 10000,
                        type: "error"
                      });
                      return;
                    }
                    
                    // Format as YYYY-MM-DD for the backend
                    const year = duplicateStartDate.getFullYear();
                    const month = String(duplicateStartDate.getMonth() + 1).padStart(2, '0');
                    const day = String(duplicateStartDate.getDate()).padStart(2, '0');
                    const dateString = `${year}-${month}-${day}`;
                    
                    const newEvent = await apiService.duplicateEvent(event!._id, { 
                      start_date: dateString
                    } as DuplicateEventDto);
                    
                    setLoading(false);
                    toggle();
                    
                    // Navigate to the new event with a flag to show success modal
                    navigate(`/e/${newEvent.handle}`, { state: { showDuplicateSuccess: true } });
                  } catch (err: any) {
                    setLoading(false);
                    const errorMessage = err?.response?.data?.message || err?.message || "Failed to duplicate event";
                    toast.show({
                      title: "Duplicate Event Failed",
                      content: errorMessage,
                      duration: 10000,
                      type: "error"
                    });
                  }
                }}
                isLoading={loading}
              >
                Duplicate Event
              </Button>
            </div>
          </div>
        );
      case "duplicateSuccess":
        return <Congrats
          title="Event Duplicated!"
          text="Your event has been successfully duplicated."
          urlText="View Event"
          action={() => {
            toggle();
            setModalContent("");
            getEvent();
          }}
        />;
      case "showForm":
        return <ShowForm
          clubId={event ? event.club_id : undefined}
          event={event ? event : undefined}
          currency={event?.currency ? event.currency : "USD"}
          onFinish={() => {
            toggle();
            getEvent(true); // Pass true to preserve scroll position

            if (editShow) {
              toast.show({
                title: "Edit Show",
                content: "You've successfully edited a show",
                duration: 10000,
                type: "success"
              });
            } else {
              toast.show({
                title: "Create Show",
                content: "You've successfully created a show",
                duration: 10000,
                type: "success"
              });
            }

            if (editShow) {
              setEditShow(undefined);
            }
          }}
          onNavigateToJudgeSchedules={editShow && event && showTypeSupportsJudgeSchedules(event.sanctioning_club, editShow.show_type) ? () => {
            setPendingModal({ content: "manageShowModal", show: editShow, tab: "Judge Schedules" });
            toggle();
            setEditShow(undefined);
          } : undefined}
          show={editShow ? editShow : undefined} />;
      case "secretaryDetails":
        return <div className="detailsInner">
          <div className="title">Secretary</div>
          <div className="nameWrap">
            <div className="name">
              {secretary?.first_name} {secretary?.last_name}
              {secretary?.is_trusted_secretary && (
                <span className="trustedSecretaryIconBadge" aria-label="Trusted secretary">
                  <img src={pawIcon} alt="Trusted secretary" />
                </span>
              )}
            </div>
            {secretary?.is_trusted_secretary && (
              <div className="trustedSecretaryText">Eager Dog Trusted Secretary</div>
            )}
          </div>
          <div className="contactInfo">
            <div className="contactItem">
              <span className="label">Phone</span>
              <div className="contactValue"><a href={"tel:" + secretary?.phone}>{secretary?.phone}</a></div>
            </div>
            <div className="contactItem">
              <span className="label">Email</span>
              <div className="contactValue"><a href={"mailto:" + secretary?.email}>{secretary?.email}</a></div>
            </div>
          </div>
        </div>;
      case "chairpersonDetails":
        return <div className="detailsInner">
          <div className="title">Chairperson</div>
          <div className="name">{chairperson?.first_name} {chairperson?.last_name}</div>
          <div className="contactInfo">
            <div className="contactItem">
              <span className="label">Phone</span>
              <div className="contactValue"><a href={"tel:" + chairperson?.phone}>{chairperson?.phone}</a></div>
            </div>
            <div className="contactItem">
              <span className="label">Email</span>
              <div className="contactValue"><a href={"mailto:" + chairperson?.email}>{chairperson?.email}</a></div>
            </div>
          </div>
        </div>;
      case "searchUsersModal":
        return <UserSearch event={event?.handle || ""} />;
      case "archiveShowModal":
        return <Confirm message={showToArchive !== undefined ? <><p>Are you sure you want to delete {showToArchive.show_type} {showToArchive.custom_show_name || showToArchive.show_name}</p></> : <></>} onConfirm={handleArchiveShow} onCancel={ () => { setShowToArchive(undefined); toggle() }} />
      case "ribbonSkipModal":
        return <RibbonSkip onSubmit={(skipAmt: number) => {
          if (event && DLShow) {
            download.pushDownload({
              type: "ribbons",
              eventId: event._id,
              showId: DLShow,
              labelsToSkip: skipAmt
            });

            toggle();
            setModalContent("");
          }
        }} />;
      case "ribbonSkipModalSmall":
        return <RibbonSkip onSubmit={(skipAmt: number) => {
          if (event && DLShow) {
            download.pushDownload({
              type: "ribbons",
              eventId: event._id,
              showId: DLShow,
              labelsToSkip: skipAmt,
              small: true
            });

            toggle();
            setModalContent("");
          }
        }} />;
      case "scoresheetLabelsModal":
        return <RibbonSkip onSubmit={(skipAmt: number) => {
          if (event && DLShow) {
            download.pushDownload({
              type: "scoresheet-labels",
              eventId: event._id,
              showId: DLShow,
              labelsToSkip: skipAmt
            });

            toggle();
            setModalContent("");
          }
        }} />;
      case "noseworkJudgeBooks":
        return <NoseworkJudgeBooksFilterModal
          onDownload={(sortOrder) => {
            if (event && DLShow) {
              download.pushDownload({
                type: "judge_books",
                eventId: event._id,
                showId: DLShow,
                judge_books_sort: sortOrder,
              });
              toggle();
              setModalContent("");
            }
          }}
          onCancel={() => {
            toggle();
            setModalContent("");
          }}
        />;
      case "precisionCoursingJudgeBooks":
        return <PrecisionCoursingJudgeBooksFilterModal
          onDownload={(sortOrder) => {
            if (event && DLShow) {
              download.pushDownload({
                type: "judge_books",
                eventId: event._id,
                showId: DLShow,
                judge_books_sort: sortOrder,
              });
              toggle();
              setModalContent("");
            }
          }}
          onCancel={() => {
            toggle();
            setModalContent("");
          }}
        />;
      case "herdingScoresheetsModal":
        return <HerdingScoresheetsFilterModal
          onDownload={(includeAlternates) => {
            if (event && DLShow) {
              download.pushDownload({
                type: "scoresheets",
                eventId: event._id,
                showId: DLShow,
                include_alternates: includeAlternates,
              });
              toggle();
              setModalContent("");
            }
          }}
          onCancel={() => {
            toggle();
            setModalContent("");
          }}
        />;
      case "judgeBooksModal":
        return <JudgeBooksFilterModal
          onDownload={(filterData) => {
            if (event && currentShowForJudgeBooks) {
              const downloadParams: any = {
                type: "judge_books",
                eventId: event._id,
                showId: currentShowForJudgeBooks._id,
                breed_filter_type: filterData.breed_filter_type
              };

              if (filterData.breed_filters && filterData.breed_filters.length > 0) {
                downloadParams.breed_filters = filterData.breed_filters;
              }

              if (filterData.breed_group_filters && filterData.breed_group_filters.length > 0) {
                downloadParams.breed_group_filters = filterData.breed_group_filters;
              }

              download.pushDownload(downloadParams);
              toggle();
              setCurrentShowForJudgeBooks(null);
            }
          }}
          onCancel={() => {
            toggle();
            setCurrentShowForJudgeBooks(null);
          }}
          preloadedBreeds={breeds}
          eventId={event?._id || ""}
          showId={currentShowForJudgeBooks?._id || ""}
        />;
      case "armbandFilterModal":
        return <ArmbandFilterModal
          shows={shows || []}
          onDownload={(params) => {
            if (event) {
              download.pushDownload({
                type: selectedArmbandType,
                eventId: event._id,
                showIds: params.show_ids,
                armNumbers: params.arm_numbers
              });
              toggle();
              setSelectedArmbandType("");
            }
          }}
          onCancel={() => {
            toggle();
            setSelectedArmbandType("");
          }}
        />;
      case "catalogShowSelect":
        return (
          <CatalogShowSelectModal
            shows={shows || []}
            timezone={event?.timezone}
            onClose={() => { toggle(); }}
            onDownload={(selectedIds) => {
              if (event) {
                download.pushDownload({
                  type: "catalog",
                  eventId: event._id,
                  showIds: selectedIds,
                });
              }
              toggle();
            }}
          />
        );
      case "judgingScheduleFieldsModal":
        return (
          <JudgingScheduleFieldsModal
            onCancel={() => { toggle(); }}
            onDownload={(options) => {
              if (event) {
                download.pushDownload({
                  type: "judge_schedules",
                  eventId: event._id,
                  include_breed: options.include_breed,
                  include_jump_height: options.include_jump_height,
                  include_call_name: options.include_call_name,
                });
              }
              toggle();
            }}
          />
        );
      case "shareModal":
        return <ShareModal
          eventTitle={event?.title || "Event"}
          eventUrl={shareEventUrl}
          onClose={() => { 
            toggle(); 
          }}
        />;
      case "emailShowRegistrantsModal":
        return <SendMessage
          isSending={isEmailingShowRegistrants}
          handleSendMessage={emailShowRegistrants}
          subject={`New Message from Organizer for ${currentShowForEmailRegistrants?.show_type} ${currentShowForEmailRegistrants?.custom_show_name || currentShowForEmailRegistrants?.show_name} - ${event?.title}`}
          type={SendMessageType.ShowRegistrants}
          onGetParticipantCount={async () => {
            if (event && currentShowForEmailRegistrants) {
              const result = await apiService.getShowParticipantCount(event._id, currentShowForEmailRegistrants._id);
              return result.count;
            }
            return 0;
          }}
          onConfirmationStateChange={setIsShowingEmailConfirmation}
        />;
      case "publishEvent":
        return <PublishEventModal toggle={() => { toggle() }} event={event} afterUpdate={() => { getEvent(true); }}/>
      case "bankPaymentProcessingModal":
        return <Congrats
          title="Payment Initiated!"
          text={<>Your bank account payment is being processed. Registration entries will be confirmed within <strong>2–3 business days</strong> once the bank transfer settles. A confirmation email will be sent once your payment clears.</>}
          urlText="View Event"
          action={() => {
            toggle();
            window.history.pushState("", "", "/e/" + eid);
          }}
          optionalAction={() => { navigate("/account?t=1"); }}
          optionalActionText="View My Registrations"
        />;
      default:
        // Check if user is already opted in to this club
        const userOptedInClubs = user?.opted_in_clubs || [];
        const isAlreadyOptedIn = event?.club_id && userOptedInClubs.includes(event.club_id);
        
        const handleCloseModal = async () => {
          // If user opted in, update their preferences
          if (optInToClubComms && event?.club_id && !isAlreadyOptedIn) {
            try {
              const updatedUser = await apiService.optInToClub(event.club_id);
              localStorageService.setItem(localStorageService.USER, JSON.stringify(updatedUser));
            } catch (error) {
              // Silent fail - don't block the modal close
            }
          }
          setOptInToClubComms(false);
          toggle();
          window.history.pushState("", "", "/e/"+ eid);
        };
        
        const handleOptionalAction = async () => {
          // If user opted in, update their preferences before navigating
          if (optInToClubComms && event?.club_id && !isAlreadyOptedIn) {
            try {
              const updatedUser = await apiService.optInToClub(event.club_id);
              localStorageService.setItem(localStorageService.USER, JSON.stringify(updatedUser));
            } catch (error) {
              // Silent fail - don't block navigation
            }
          }
          setOptInToClubComms(false);
          if (behalf === "true") {
            navigate("/e/"+ eid +"/manage");
          } else if (payClubDirectly === "true") {
            navigate("/account?t=4");
          } else {
            navigate("/account?t=1");
          }
        };
        
        const congratsTitle = payClubDirectly === "true"
          ? "You're not done yet!"
          : isLotteryRedirect
            ? "You're in the draw!"
            : "Congratulations!";

        const congratsText = payClubDirectly === "true"
          ? <>Your entries have been submitted to the club but are not confirmed until the club confirms your payment. <strong>Proceed to the event administrators to make your payment and obtain your armband number(s) if applicable.</strong></>
          : behalf === "true"
            ? "You've successfully registered the user for your event. A copy of the receipt has been sent to their email."
            : isLotteryRedirect
              ? <>Your entries have been submitted for the random draw. You won't be charged until the draw is run.<br/><br/>Once the draw is complete, you'll receive an email with the outcome of each entry. If selected, you'll be directed to finalize your payment at that time.</>
              : waitlist === "true"
                ? <>You've successfully registered for the event. A receipt has been sent to your email.<br/><br/>Some of your entries are waitlisted. We'll notify you when your status on the waitlist is updated.</>
                : "You've successfully registered for the event. A receipt has been sent to your email.";
        
        return <Congrats
          title={congratsTitle}
          text={congratsText}
          totalCharged={behalf === "true" || payClubDirectly === "true" || isLotteryRedirect ? undefined : totalCharged}
          pointsUsed={behalf === "true" || payClubDirectly === "true" || isLotteryRedirect ? undefined : pointsUsed}
          remainingPoints={behalf === "true" || payClubDirectly === "true" || isLotteryRedirect ? undefined : remainingPoints}
          urlText={"View Event"}
          action={handleCloseModal}
          optionalAction={handleOptionalAction}
          optionalActionText={behalf === "true" ? "View Registrants" : payClubDirectly === "true" ? "View Transactions" : isLotteryRedirect ? "View My Entries" : waitlist === "true" ? "View My Registrations" : "View Registrations"}
          extraContent={
            behalf !== "true" && !isAlreadyOptedIn && event?.club?.club_name ? (
              <Checkbox
                id="opt-in-club-comms"
                label={`Keep me updated on upcoming events, courses, and promotions from ${event.club.club_name}`}
                value={optInToClubComms}
                onChange={(e) => setOptInToClubComms(e.target.checked)}
              />
            ) : null
          }
        />;
    }
  }

  const handleArchiveShow = () => {
    if (!showToArchive) {
      return;
    }

    apiService.updateShow(event!._id, showToArchive._id, { ...showToArchive as ShowDto, is_archived: true})
      .then(() => { getEvent(); })
      .catch((e: AxiosError) => {
        toast.show({
          title: "Archive Show",
          content: "Unable to archive show",
          errorDetails: e,
          duration: 10000,
          type: "fail"
        });
      });

      setShowToArchive(undefined);
      toggle()
  }

  const emailShowRegistrants = async (payload: IEventMessage) => {
    if (!event || !currentShowForEmailRegistrants) {
      return;
    }

    setIsEmailingShowRegistrants(true);
    
    // Close modal immediately for better UX
    toggle();

    try {
      // Get participant count for the success message
      const participantCountResult = await apiService.getShowParticipantCount(event._id, currentShowForEmailRegistrants._id);
      const participantCount = participantCountResult.count;

      const content = payload.is_test_sending 
        ? `Test email sent to ${event.club?.email || 'club email'}.` 
        : `Your message has been sent to ${participantCount} participants for ${currentShowForEmailRegistrants.custom_show_name || currentShowForEmailRegistrants.show_name}.`;

      await apiService.requestSendMessageEmailForShow(event._id, currentShowForEmailRegistrants._id, payload);
      
      toast.show({
        title: "Email Results",
        content,
        duration: 10000,
        type: "success"
      });
    } catch (e: any) {
      toast.show({
        title: "Email Results",
        content: "Unable to email results",
        duration: 10000,
        errorDetails: e,
        type: "fail"
      });
    } finally {
      setIsEmailingShowRegistrants(false);
      setCurrentShowForEmailRegistrants(null);
    }
  }

  const handleArchiveEvent = () => {
    const { __v: _archiveVersion, ...archiveEvent } = event as EventDto & { __v?: number };
    apiService.updateEvent(event!._id, { ...archiveEvent, is_archived: true }).then(() => {
      toast.show({
        title: "Delete Event",
        content: "You've successfully archived your event",
        duration: 10000,
        type: "success"
      });

      navigate("/");
    }).catch(error => {
      toast.show({
        title: "Delete Event",
        content: "Unable to archive event",
        errorDetails: error,
        duration: 10000,
        type: "fail"
      });
    });
  }

  useEffect(() => {
    if (event === undefined && !loading) {
      setLoading(true);
      getEvent();

      const queryParameters = new URLSearchParams(window.location.search);
      const redirectStatus = queryParameters.get("redirect_status");

      if (redirectStatus === "succeeded") {
        setModalContent("congratsModal");
      } else if (redirectStatus === "processing") {
        setModalContent("bankPaymentProcessingModal");
      }
    }
  }, [getEvent, event, loading]);

  // When returning from a bank account (ACSS/ACH) payment, immediately trigger
  // registration processing so entries appear without waiting for the Stripe webhook.
  const bankPaymentReturnHandled = useRef(false);
  useEffect(() => {
    if (!event || bankPaymentReturnHandled.current) return;
    const queryParameters = new URLSearchParams(window.location.search);
    const redirectStatus = queryParameters.get("redirect_status");
    const paymentIntentId = queryParameters.get("payment_intent");
    if (redirectStatus === "processing" && paymentIntentId) {
      bankPaymentReturnHandled.current = true;
      apiService.processBankPaymentReturn(event._id, paymentIntentId).catch((err) => {
        console.error("processBankPaymentReturn failed:", err);
      });
    }
  }, [event]);

  // Removed automatic scroll-to-top on eid change to prevent unwanted scrolling
  // The browser handles scroll restoration for actual navigation
  // For intentional scrolling, use scrollToTop() from utils/scrollHelpers

  useEffect(() => {
    if (event && !loading && !isAdmin) {
      const isLotteryEvent = event.is_lottery
      const declineToken = isLotteryEvent ? "decline_lottery_invite" : "decline_waitlisted_invite";
      const declineParam = searchParams.get(declineToken);

      if (declineParam && !waitlistedDeclineHandled) {
        const declineFunction = isLotteryEvent ? apiService.declineLotteryInvite : apiService.declineWaitlistedInvite
        declineFunction(event!._id)
          .then(() => {
            const params = new URLSearchParams(searchParams);
            params.delete(declineToken);
            setSearchParams(params);

            toast.show({
              title: isLotteryEvent ? "Random Draw Event" : "Event",
              content: `You've successfully declined the ${isLotteryEvent ? "random draw" : ""} event invitation.`,
              duration: 10000,
              type: "success"
            });
          })
          .catch((err) => {
            toast.show({
              title: isLotteryEvent ? "Random Draw Event" : "Event",
              content: `Couldn't decline the ${isLotteryEvent ? "random draw" : ""} event invitation. Please try to refresh the page.`,
              duration: 10000,
              type: "fail"
            });
          })
          .finally(() => {
            setWaitlistedDeclineHandled(true);
          });
      }
    }
  }, [event, isAdmin, loading, waitlistedDeclineHandled, searchParams, setSearchParams]);

  // Load breeds data for the judge books filter modal
  useEffect(() => {
    const loadBreeds = async () => {
      try {
        const breedsData = await apiService.getBreeds();
        setBreeds(breedsData);
      } catch (error) {
        // Failed to load breeds
      }
    };

    loadBreeds();
  }, []);

  const pModalContent = helperService.usePrevious(modalContent);

  useEffect(() => {
    if (pModalContent !== modalContent) {
      if (modalContent !== "") {
        toggle();
      } else {
        let requiresReload:string[] = [
          "manageShowModal"
        ];

        if (pModalContent && requiresReload.includes(pModalContent)) {
          getEvent(true); // Preserve scroll position when reloading after modal closes
        }
      }
    } else {
      if (!isShown) {
        setModalContent("");
        setManageShowInitialTab(undefined); // Clear initial tab when modal closes
      }
    }
  }, [isShown, modalContent, pModalContent, setModalContent, toggle, getEvent]);

  // After modal fully closes, open any pending modal (e.g. switching from Edit Show → Manage Show)
  useEffect(() => {
    if (!isShown && modalContent === "" && pendingModal) {
      setManageShow(pendingModal.show);
      setManageShowInitialTab(pendingModal.tab);
      setModalContent(pendingModal.content);
      setPendingModal(null);
    }
  }, [isShown, modalContent, pendingModal]);

  const pIsAdmin = helperService.usePrevious(isAdmin);

  useEffect(() => {
    if (pIsAdmin !== isAdmin && isAdmin === true) {
      setScheduleHeaders([...scheduleHeaders, { label: "Actions", id: "actions" }]);
      const _shows = [...tableShows];

      for (let s in _shows) {
        if (shows) {
          _shows[s] = setShowActions(_shows[s], event, shows[parseInt(s)], true);
        }
      }

      setTableShows(_shows);
    }
  }, [pIsAdmin, isAdmin, event, scheduleHeaders, tableShows, shows, eid, navigate, setShowActions]);



  let _eid:string|undefined = eid ? eid : props.eid;

  const { setTab, activeTab } = useTabContent();

  const onCreateShowClick = () => {
    // Preserve scroll position before opening modal
    const scrollY = window.scrollY || window.pageYOffset;
    sessionStorage.setItem('eventPageScrollPosition', scrollY.toString());
    setEditShow(undefined);
    setModalContent("showForm");
  };

  const renderSchedule = () => {
    if (tableShows.length === 0) {
      return (
        <div className="scheduleWrap">
          {isAdmin && (
            <div className="scheduleActions">
              <Button onClick={onCreateShowClick}>Create a Show</Button>
            </div>
          )}
          <Table
            headers={scheduleHeaders}
            data={[]}
            emptyMsg={<div className="emptyTable"><span>This event doesn't have any shows, yet.</span></div>}
          />
        </div>
      );
    }

    return (
      <div className="scheduleWrap">
        {isAdmin && (
          <div className="scheduleActions">
            <Button onClick={onCreateShowClick}>Create a Show</Button>
          </div>
        )}
        <div className="Table">
        <div className="headers">
          {scheduleHeaders.map((h: IHeader, index: number) => (
            <div key={index} className={"header no-select " + h.id}>
              <span>{h.label === "Actions" ? "" : h.label}</span>
              <span className="sort"></span>
            </div>
          ))}
        </div>
        <div className="data">
          {tableShows.map((row: IShowTable, rowIndex: number) => {
            const correspondingShow = shows?.find(s => s._id.toString() === row.id);
            // Always show capacity row for admins to allow setting limits
            const showCapacity = correspondingShow && isAdmin;
            
            return (
              <React.Fragment key={row.id}>
                <div className="row">
                  {Object.entries(row).map((d: any, index2: number) => {
                    if (d[0] !== "id") {
                      if (d[0] === "actions") {
                        return (
                          <div key={index2} className="cell actions">
                            <ul className="actionList">
                              {d[1].map((action: IRowAction, actionIndex: number) => (
                                <li key={actionIndex} onClick={() => {
                                  if (action.onClick) {
                                    action.onClick();
                                  } else if (action.options) {
                                    if (toggleRow === rowIndex && toggleIcon === actionIndex) {
                                      setToggleRow(-1);
                                      setToggleIcon(-1);
                                    } else {
                                      setToggleIcon(actionIndex);
                                      setToggleRow(rowIndex);
                                    }
                                  }
                                }}>
                                  <div className={"iconWrap" + (action.className ? ` ${action.className}` : "")}>
                                    <div className={"icon " + action.icon}></div>
                                    {action.label && <span className="actionLabel">{action.label}</span>}
                                    {action.options && (
                                      <ul className={toggleRow === rowIndex && actionIndex === toggleIcon ? "actionOptions no-select" : "actionOptions hidden no-select"}>
                                        {action.options.map((option: ITableDropAction, index3: number) => (
                                          <li key={index3} onClick={(e) => { e.stopPropagation(); option.onClick(); setToggleRow(-1); setToggleIcon(-1); }}>
                                            {option.label}
                                          </li>
                                        ))}
                                      </ul>
                                    )}
                                  </div>
                                </li>
                              ))}
                            </ul>
                          </div>
                        );
                      } else {
                        const isElement = React.isValidElement(d[1]);
                        const isPrimitive = d[1] === null || d[1] === undefined || typeof d[1] !== "object";
                        const displayValue = isElement || isPrimitive ? d[1] : "";
                        return (
                          <div key={index2} title={typeof d[1] === 'object' ? undefined : d[1]} className={"cell " + d[0]}>
                            <div className="cellWrap">
                              <span>
                                {displayValue}
                              </span>
                            </div>
                          </div>
                        );
                      }
                    }
                    return null;
                  })}
                </div>
                {showCapacity && (
                  <ShowCapacityRow 
                    show={correspondingShow} 
                    metrics={showCapacityMetrics.find(m => m.show_id === correspondingShow._id.toString())}
                    eventTimezone={event?.timezone}
                    onSetLimit={() => {
                      const scrollY = window.scrollY || window.pageYOffset;
                      sessionStorage.setItem('eventPageScrollPosition', scrollY.toString());
                      setManageShow(correspondingShow);
                      setManageShowInitialTab("Waitlist");
                      setModalContent("manageShowModal");
                    }}
                    onViewWaitlist={() => {
                      if (eventKey) {
                        const params = new URLSearchParams();
                        params.set("tab", "Waitlist");
                        params.set("waitlist_show", correspondingShow._id.toString());

                        const adminParam = searchParams.get("admin");
                        if (adminParam) {
                          params.set("admin", adminParam);
                        }

                        navigate(`/e/${eventKey}/manage?${params.toString()}`);
                      }
                    }}
                  />
                )}
                {correspondingShow && !isAdmin && (
                  <ShowElementsRow show={correspondingShow} />
                )}
              </React.Fragment>
            );
          })}
        </div>
        </div>
      </div>
    );
  }

  const renderRealtimeRunOrder = () => {
    if (!event || !shows) return null;
    
    return (
      <RealtimeRunOrderTab 
        event={event} 
        shows={shows}
      />
    );
  }

  const renderHotelsTab = () => {
    if (!event) return null;

    return (
      <HotelsTab event={event} isAdmin={isAdmin} onHotelsChange={setHotels} />
    );
  }

  const renderDocumentsTab = () => {
    if (!event) return null;

    return (
      <DocumentsTab event={event} isAdmin={isAdmin} />
    );
  }

  const openEditJudgeSchedule = () => {
    if (!event) return;
    const anchor = (shows || []).find((show) => showTypeSupportsJudgeSchedules(event.sanctioning_club, show.show_type));
    if (anchor) setScheduleBuilderShow(anchor);
  };

  const getAdminMenu = (sanctioning_club: string) => {
    // Check if any shows in the event support judge schedules (for UKC)
    const hasJudgeScheduleShows = shows?.some(show => 
      show.show_type === Constants.show_type.nosework ||
      show.show_type === Constants.show_type.obedience ||
      show.show_type === Constants.show_type.rally_obedience ||
      show.show_type === Constants.show_type.conformation
    ) || false;

    const hasConformationShows = shows?.some(
      (show) => show.show_type === Constants.show_type.conformation
    ) || false;

    const editJudgeScheduleOption = event && (shows || []).some((show) => showTypeSupportsJudgeSchedules(sanctioning_club, show.show_type))
      ? <li onClick={() => { setShowMore(false); openEditJudgeSchedule(); }}>Edit Judge Schedule</li>
      : null;

    switch(sanctioning_club) {
    case Constants.sanctioning_club.UKC:
      return (<ul className="actionOptions">
        <li onClick={() => {
          setShowMore(false);

          download.pushDownload({
            type: "ukc_event_counts",
            eventId: event!._id
          });
        }}>Download Event Counts</li>
        {hasConformationShows && <li onClick={() => {
          setShowMore(false);

          download.pushDownload({
            type: "ukc_event_counts_formatted",
            eventId: event!._id
          });
        }}>Download Event Counts (Formatted)</li>}
        <li onClick={() => {
          setShowMore(false);

          download.pushDownload({
            type: "ukc_total_dog_report",
            eventId: event!._id
          });
        }}>Download UKC Total Dog Report</li>
        {hasJudgeScheduleShows && <li onClick={() => {
          setShowMore(false);

          download.pushDownload({
            type: "judge_schedules",
            eventId: event!._id
          });
        }}>Download Judge Schedules</li>}
        {(event?.handle === "wyip3b" || event?.handle === "2az1nm") && <li onClick={() => {
          setShowMore(false);

          download.pushDownload({
            type: "interwoven_judge_schedule",
            eventId: event!._id
          });
        }}>Download Interwoven Judge Schedule</li>}
        {hasConformationShows && <li onClick={() => {
          setShowMore(false);

          download.pushDownload({
            type: "judge_breeds_event",
            eventId: event!._id
          });
        }}>Download Judge Breeds</li>}
        {/* Download Transaction Summary hidden — per-show allocation doesn't reconcile cleanly */}
        {editJudgeScheduleOption}
      </ul>);
    case Constants.sanctioning_club.AKC: {
      const hasScentwork = shows?.some(show => show.show_type === Constants.show_type.scentwork) || false;
      const hasObedience = shows?.some(show => show.show_type === Constants.show_type.obedience) || false;
      const fetchOnly = (shows?.length ?? 0) > 0 && shows!.every(show => show.show_type === Constants.show_type.fetch);
      return (<ul className="actionOptions">
        {!fetchOnly && <li onClick={() => {
          setShowMore(false);
          setModalContent("catalogShowSelect");
        }}>Download Event Catalog</li>}
        <li onClick={() => {
          setShowMore(false);
          setModalContent("judgingScheduleFieldsModal");
        }}>Download Judge Schedules</li>
        {hasObedience && <li onClick={() => {
          setShowMore(false);
          download.pushDownload({ type: "akc_udx_combined_list", eventId: event!._id });
        }}>Download UDX Combined List</li>}
        {hasScentwork && <li onClick={() => {
          setShowMore(false);
          download.pushDownload({ type: "akc_results", eventId: event!._id });
        }}>Download AKC Results XML</li>}
        {event?.handle === "2az1nm" && <li onClick={() => {
          setShowMore(false);

          download.pushDownload({
            type: "interwoven_judge_schedule",
            eventId: event!._id
          });
        }}>Download Interwoven Judge Schedule</li>}
        {/* Download Transaction Summary hidden — per-show allocation doesn't reconcile cleanly */}
        {editJudgeScheduleOption}
      </ul>);
    }
      case Constants.sanctioning_club.PWDCA:
        return (<ul className="actionOptions">
          <li onClick={() => {
            setShowMore(false);
            setModalContent("catalogShowSelect");
        }}>Download Event Catalog</li>
        {/* Download Transaction Summary hidden — per-show allocation doesn't reconcile cleanly */}
        {/*<li onClick={() => {*/}
        {/*  setShowMore(false);*/}

        {/*  download.pushDownload({*/}
        {/*    type: "judge_schedules",*/}
        {/*    eventId: event!._id*/}
        {/*  });*/}
        {/*}}>Download Judge Schedules</li>*/}
        {editJudgeScheduleOption}
      </ul>);
      case Constants.sanctioning_club.BHA:
        return (<ul className="actionOptions">
          <li onClick={() => {
            setShowMore(false);

            download.pushDownload({
              type: "judge_schedules",
              eventId: event!._id
            });
          }}>Download Judge Schedules</li>
          {/* Download Transaction Summary hidden — per-show allocation doesn't reconcile cleanly */}
          {editJudgeScheduleOption}
      </ul>);
    case Constants.sanctioning_club.C_WAGS:
      const hasTrialShows = shows?.some(show => 
        show.show_type === Constants.show_type.scent ||
        show.show_type === Constants.show_type.obedience ||
        show.show_type === Constants.show_type.rally_obedience
      ) || false;
      
      const hasJudgeScheduleShowsCWags = shows?.some(show => 
        show.show_type === Constants.show_type.scent ||
        show.show_type === Constants.show_type.obedience ||
        show.show_type === Constants.show_type.rally_obedience
      ) || false;
      
      return (<ul className="actionOptions">
        {hasJudgeScheduleShowsCWags && <li onClick={() => {
          setShowMore(false);

          download.pushDownload({
            type: "judge_schedules",
            eventId: event!._id
          });
        }}>Download Judge Schedules</li>}
        {hasTrialShows && <li onClick={() => {
          setShowMore(false);

          download.pushDownload({
            type: "cwags_scent_results",
            eventId: event!._id
          });
        }}>Download Trial Results</li>}
        {/* Download Transaction Summary hidden — per-show allocation doesn't reconcile cleanly */}
        {editJudgeScheduleOption}
      </ul>);
      case Constants.sanctioning_club.FH: {
      const hasFHScheduleShows = shows?.some(show =>
        show.show_type === Constants.show_type.rally_obedience ||
        show.show_type === Constants.show_type.agility
      ) || false;
      return (<ul className="actionOptions">
        {hasFHScheduleShows && <li onClick={() => {
          setShowMore(false);
          download.pushDownload({
            type: "judge_schedules",
            eventId: event!._id
          });
        }}>Download Judge Schedules</li>}
        {editJudgeScheduleOption}
      </ul>);
    }
  }

  return null;
}

  const openArmbandModal = (e: React.MouseEvent, armbandType: string) => {
    e.stopPropagation();
    setShowArmbandMenu(false);
    setSelectedArmbandType(armbandType);
    setModalContent("armbandFilterModal");
    // Note: Don't call toggle() here - the useEffect will handle it when modalContent changes
  };

  const getArmbandMenu = (sanctioning_club: string) => {
    switch(sanctioning_club) {
      case Constants.sanctioning_club.UKC:
        return (<ul className="actionOptions">
          <li onClick={() => {
              setShowArmbandMenu(false);
              setShowGenerateArmbandConfirm(true);
            }}>Generate Armband Numbers</li>
          <li onClick={(e) => openArmbandModal(e, "armband_labels")}>Download Armband Labels (Front)</li>
          <li onClick={(e) => openArmbandModal(e, "armband_labels_back")}>Download Armband Labels (Back)</li>
          <li onClick={(e) => openArmbandModal(e, "armband_labels")}>Download Armband Labels (5163)</li>
          <li onClick={(e) => openArmbandModal(e, "armband_labels_5919")}>Download Armband Labels (5919)</li>
          <li onClick={(e) => openArmbandModal(e, "armband_labels_5919_back")}>Download Armband Labels (5919 Back)</li>
          <li onClick={(e) => openArmbandModal(e, "armband_labels_5919_detail")}>Download Armband Labels (5919 Detail)</li>
          <li onClick={(e) => openArmbandModal(e, "armband_labels_5162")}>Download Armband Labels (5162)</li>
          <li onClick={(e) => openArmbandModal(e, "armband_labels_5164")}>Download Armband Labels (5164)</li>
          <li onClick={(e) => openArmbandModal(e, "armband_labels_5164_back")}>Download Armband Labels (5164 Back)</li>
          <li onClick={(e) => openArmbandModal(e, "armband_labels_3perpage")}>Download Armband Labels (3 per page)</li>
          <li onClick={(e) => openArmbandModal(e, "armband_labels_4perpage")}>Download Armband Labels (4 per page)</li>
          <li onClick={() => {
            setShowArmbandMenu(false);
            setShowResetArmbandConfirm(true);
          }}>Reset Armband Numbers</li>
        </ul>);
      
      case Constants.sanctioning_club.AKC:
      case Constants.sanctioning_club.PWDCA:
      case Constants.sanctioning_club.ISWS:
      case Constants.sanctioning_club.FH: {
        const fetchOnly = (shows?.length ?? 0) > 0 && shows!.every(show => show.show_type === Constants.show_type.fetch);
        return (<ul className="actionOptions">
          <li onClick={() => {
            setShowArmbandMenu(false);
            setShowGenerateArmbandConfirm(true);
          }}>Generate Armband Numbers</li>
          <li onClick={(e) => openArmbandModal(e, "armband_labels")}>Download Armband Labels (5163)</li>
          <li onClick={(e) => openArmbandModal(e, "armband_labels_5919")}>Download Armband Labels (5919)</li>
          <li onClick={(e) => openArmbandModal(e, "armband_labels_5919_back")}>Download Armband Labels (5919 Back)</li>
          <li onClick={(e) => openArmbandModal(e, "armband_labels_5919_detail")}>Download Armband Labels (5919 Detail)</li>
          {!fetchOnly && <li onClick={(e) => openArmbandModal(e, "armband_labels_5162")}>Download Armband Labels (5162)</li>}
          <li onClick={(e) => openArmbandModal(e, "armband_labels_5164")}>Download Armband Labels (5164)</li>
          <li onClick={(e) => openArmbandModal(e, "armband_labels_5164_back")}>Download Armband Labels (5164 Back)</li>
          <li onClick={(e) => openArmbandModal(e, "armband_labels_3perpage")}>Download Armband Labels (3 per page)</li>
          <li onClick={(e) => openArmbandModal(e, "armband_labels_4perpage")}>Download Armband Labels (4 per page)</li>
          <li onClick={() => {
            setShowArmbandMenu(false);
            setShowResetArmbandConfirm(true);
          }}>Reset Armband Numbers</li>
        </ul>);
      }

      case Constants.sanctioning_club.BHA:
        return (<ul className="actionOptions">
          <li onClick={(e) => openArmbandModal(e, "armband_labels")}>Download Armband Labels (5163)</li>
          <li onClick={(e) => openArmbandModal(e, "armband_labels_5919")}>Download Armband Labels (5919)</li>
          <li onClick={(e) => openArmbandModal(e, "armband_labels_5919_back")}>Download Armband Labels (5919 Back)</li>
          <li onClick={(e) => openArmbandModal(e, "armband_labels_5919_detail")}>Download Armband Labels (5919 Detail)</li>
          <li onClick={(e) => openArmbandModal(e, "armband_labels_5162")}>Download Armband Labels (5162)</li>
          <li onClick={(e) => openArmbandModal(e, "armband_labels_5164")}>Download Armband Labels (5164)</li>
          <li onClick={(e) => openArmbandModal(e, "armband_labels_5164_back")}>Download Armband Labels (5164 Back)</li>
          <li onClick={(e) => openArmbandModal(e, "armband_labels_3perpage")}>Download Armband Labels (3 per page)</li>
          <li onClick={(e) => openArmbandModal(e, "armband_labels_4perpage")}>Download Armband Labels (4 per page)</li>
        </ul>);
    }

    return (<ul className="actionOptions">
      <li onClick={(e) => openArmbandModal(e, "armband_labels")}>Download Armband Labels (5163)</li>
      <li onClick={(e) => openArmbandModal(e, "armband_labels_5919")}>Download Armband Labels (5919)</li>
      <li onClick={(e) => openArmbandModal(e, "armband_labels_5919_back")}>Download Armband Labels (5919 Back)</li>
      <li onClick={(e) => openArmbandModal(e, "armband_labels_5919_detail")}>Download Armband Labels (5919 Detail)</li>
      <li onClick={(e) => openArmbandModal(e, "armband_labels_5162")}>Download Armband Labels (5162)</li>
      <li onClick={(e) => openArmbandModal(e, "armband_labels_5164")}>Download Armband Labels (5164)</li>
      <li onClick={(e) => openArmbandModal(e, "armband_labels_3perpage")}>Download Armband Labels (3 per page)</li>
      <li onClick={(e) => openArmbandModal(e, "armband_labels_4perpage")}>Download Armband Labels (4 per page)</li>
    </ul>);
  }


  const onGenerateArmbandNumbers = () => {
    setShowGenerateArmbandConfirm(false);
    apiService.generateArmNumbersPerShowType(event!._id).then(() => {
      toast.show({
        title: "Generate Armband Numbers",
        content: "Armband Numbers generated successfully",
        duration: 10000,
        type: "success"
      });
    }).catch((e: AxiosError) => {
      toast.show({
        title: "Generate Armband Numbers",
        content: "Unable to generate armband numbers",
        errorDetails: e,
        duration: 10000,
        type: "fail"
      });
    });
  };

  const onResetArmbandNumbers = () => {
    setShowResetArmbandConfirm(false);
    apiService.resetArmNumbers(event!._id)
      .then(() => {
        toast.show({
          title: "Reset Armband Numbers",
          content: "All armband numbers have been reset successfully",
          duration: 10000,
          type: "success"
        });
        // Refresh event data to update UI
        getEvent();
      })
      .catch((e: AxiosError) => {
        toast.show({
          title: "Reset Armband Numbers",
          content: "Unable to reset armband numbers",
          errorDetails: e,
          duration: 10000,
          type: "fail"
        });
      });
  }

  const handleRunLottery = () => {
    setLotteryShuffleLoading(true);

    apiService.runLotteryEvent(event!._id)
      .then((response) => {
        setEvent(response);
        toast.show({
          title: "Random Draw",
          content: "The random draw has been run. Winners have been notified and charges are being processed.",
          duration: 10000,
          type: "success"
        });
      })
      .catch((err) => {
        const errorMessage = err?.response?.data?.message || err?.message || "Failed to run the random draw";
        toast.show({
          title: "Random Draw",
          content: errorMessage,
          duration: 10000,
          type: "fail"
        });
      })
      .finally(() => {
        setLotteryShuffleLoading(false);
      });
  }

  // Check if event is live (registration is open)
  const isEventLive = () => {
    if (!event) return false;
    
    // Published events are always live
    if (event.status === Constants.event_status.published) {
      return true;
    }
    
    // Upcoming events are live if publish_at has passed (or doesn't exist)
    if (event.status === Constants.event_status.upcoming) {
      if (!event.publish_at) {
        return true; // No publish_at means it's live
      }
      return new Date(event.publish_at) <= new Date();
    }
    
    return false;
  };

  const publishedRegisterButtonLabel = (registeredDogsLength: number) => {
    if (event && fullnessShows.length > 0 && fullnessShows.every(show => show.is_full)) {
      return <div className="disabled-register"><span>This event is full</span></div>
    }
    
    // Check if user is logged in
    if (!user._id || !helperService.isLoggedIn()) {
      return <Link to={`/login?r=/e/${_eid}/register`}>{registeredDogsLength > 0 ? "Register Again" : "Register"}</Link>
    }
    
    return <Link to={"/e/" + _eid + "/register"}>{registeredDogsLength > 0 ? "Register Again" : "Register"}</Link>
  }



  return(
    <div className="Event">
        {event && <Helmet>
          <title>{event?.title} Event - {event?.club_name ?? event?.club.club_name}</title>
          <meta name="description" content={`Join us for ${event?.title}, a ${event?.sanctioning_club} sanctioned dog event hosted by ${event?.club_name ?? event?.club.club_name} on ${moment(event?.start_date).format('dddd, MMMM Do, YYYY')} in ${event?.address?.city}, ${event?.address?.state}. Register now for this exciting dog show!`} />
          <meta name="robots" content="index, follow" />
          <meta name="keywords" content={`dog show, dog event, ${event?.sanctioning_club}, ${event?.title}, ${event?.club_name ?? event?.club.club_name}, ${event?.address?.city}, ${event?.address?.state}, dog competition, pet event`} />
          
          {/* Open Graph / Facebook */}
          <meta property="og:type" content="event" />
          <meta property="og:title" content={`${event?.title} - ${event?.sanctioning_club} Dog Event`} />
          <meta property="og:description" content={`Join us for ${event?.title}, a ${event?.sanctioning_club} sanctioned dog event on ${moment(event?.start_date).format('MMMM Do, YYYY')} in ${event?.address?.city}, ${event?.address?.state}. Hosted by ${event?.club_name ?? event?.club.club_name}.`} />
          <meta property="og:url" content={window.location.href} />
          <meta property="og:image" content={`${window.location.origin}/socialshare.png`} />
          <meta property="og:image:width" content="1080" />
          <meta property="og:image:height" content="1080" />
          <meta property="og:image:alt" content={`${event?.title} dog event promotional image`} />
          <meta property="og:site_name" content="Eager Dog" />
          <meta property="og:locale" content="en_US" />
          
          {/* Event specific OG tags */}
          <meta property="event:start_time" content={event?.start_date ? moment(event?.start_date).toISOString() : ''} />
          <meta property="event:end_time" content={event?.end_date ? moment(event?.end_date).toISOString() : ''} />
          <meta property="event:location:latitude" content="" />
          <meta property="event:location:longitude" content="" />
          <meta property="event:location:street_address" content={event?.address?.line1 || ''} />
          <meta property="event:location:locality" content={event?.address?.city || ''} />
          <meta property="event:location:region" content={event?.address?.state || ''} />
          <meta property="event:location:country_name" content={event?.address?.country || ''} />
          <meta property="event:location:postal_code" content={event?.address?.postal_code || ''} />
          
          {/* Twitter / X */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={`${event?.title} - ${event?.sanctioning_club} Dog Event`} />
          <meta name="twitter:description" content={`Join us for ${event?.title} on ${moment(event?.start_date).format('MMMM Do, YYYY')} in ${event?.address?.city}, ${event?.address?.state}. Register now!`} />
          <meta name="twitter:image" content={`${window.location.origin}/socialshare.png`} />
          <meta name="twitter:image:alt" content={`${event?.title} dog event promotional image`} />
          <meta name="twitter:site" content="@EagerDog" />
          <meta name="twitter:creator" content="@EagerDog" />
          
          {/* Additional SEO */}
          <meta name="author" content={event?.club_name ?? event?.club.club_name} />
          <meta name="publisher" content="Eager Dog" />
          <link rel="canonical" href={window.location.href} />
          
          {/* JSON-LD Structured Data */}
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Event",
              "name": event?.title,
              "description": `${event?.title}, a ${event?.sanctioning_club} sanctioned dog event hosted by ${event?.club_name ?? event?.club.club_name}`,
              "startDate": event?.start_date ? moment(event?.start_date).toISOString() : '',
              "endDate": event?.end_date ? moment(event?.end_date).toISOString() : '',
              "eventStatus": "https://schema.org/EventScheduled",
              "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
              "location": {
                "@type": "Place",
                "name": `${event?.address?.line1}, ${event?.address?.city}, ${event?.address?.state}`,
                "address": {
                  "@type": "PostalAddress",
                  "streetAddress": event?.address?.line1,
                  "addressLocality": event?.address?.city,
                  "addressRegion": event?.address?.state,
                  "postalCode": event?.address?.postal_code,
                  "addressCountry": event?.address?.country
                }
              },
              "organizer": {
                "@type": "Organization",
                "name": event?.club_name ?? event?.club.club_name,
                "url": "https://eagerdog.com"
              },
              "offers": {
                "@type": "Offer",
                "url": window.location.href,
                "price": "0",
                "priceCurrency": "USD",
                "availability": "https://schema.org/InStock",
                "validFrom": new Date().toISOString()
              },
              "image": [`${window.location.origin}/socialshare.png`],
              "performer": {
                "@type": "Organization",
                "name": event?.club_name ?? event?.club.club_name
              }
            })}
          </script>
        </Helmet>}
        <div className="eventInner">
          {!loading && event?.status === Constants.event_status.draft && user?.user_type === Constants.user_type.club_manager && (
            <div className="draftBanner">
              <div className="draftBannerContent">
                <div className="draftBannerText">
                  This event is currently not visible to competitors. Be sure to publish it when you're ready.
                </div>
              </div>
              <Button className="draftBannerButton" onClick={() => setModalContent("publishEvent")}>Publish Now</Button>
            </div>
          )}
          {!loading &&<div className="eventDetails eventDetailsV2">
            {/* Header Section */}
            <div className="headerSection">
              <div className="headerTopRow">
                <div className="statusRow">
                  <div className="labelsWrapper">
                    <span 
                      className={"statusLabel " + (isPastEvent ? "finished" : event?.status) + (isAdmin && !isPastEvent ? " clickable" : "")}
                      onClick={() => {
                        if (isAdmin && !isPastEvent) {
                          setEventFormInitialTab(7); // Visibility tab index
                          setModalContent("eventForm");
                        }
                      }}
                    >
                      {isPastEvent ? "Finished" : (event ? helperService.getEventStatus(event?.status) : "")}
                    </span>
                    {isLotteryDrawOpen(event) && !isPastEvent && <span className="lotteryLabel">Random Draw</span>}
                  </div>
                  {!isPastEvent && event?.publish_at && event?.status === "draft" && <span className="publishTime">Set to go live on {moment(event?.publish_at).tz(event.timezone || moment.tz.guess()).format("MMMM Do, YYYY @ h:mma zz")}</span>}
                  {!isPastEvent && event?.publish_at && event?.status === "upcoming" && <span className="publishTime">Set to go live on {moment(event?.publish_at).tz(event.timezone || moment.tz.guess()).format("MMMM Do, YYYY @ h:mma zz")}</span>}
                  {!isPastEvent && event?.publish_at && event?.status === "published" && !isLotteryDrawOpen(event) && <span className="publishTime">Live on {moment(event?.publish_at).tz(event.timezone || moment.tz.guess()).format("MMMM Do, YYYY @ h:mma zz")}</span>}
                  {!isPastEvent && event?.publish_at && event?.status === "published" && isLotteryDrawOpen(event) && <span className="publishTime">
                    {!!event?.lottery_end_date ? `Random Draw Registration Ends ${moment(event?.lottery_end_date).tz(event.timezone || moment.tz.guess()).format("MMMM Do, YYYY @ ha zz")}.  ` : ''}
                  </span>}
                  {isPastEvent && <span className="publishTime">Event ended on {moment(event?.end_date).tz(event?.timezone || moment.tz.guess()).format("MMMM Do, YYYY")}</span>}
                </div>
                {isAdmin && <div className="circleButtons">
                  <div className="btnWrap"><button onClick={() => { setModalContent("eventForm"); }} className="edit" title="Edit Event">Edit Event</button></div>
                  <div className="btnWrap"><Link to={getManageUrl()} className="manage" title="Manage Event">Manage Event</Link></div>
                  <div className="btnWrap"><button onClick={() => { setModalContent("shareModal"); }} className="share" title="Share Event">Share Event</button></div>
                  {event && ([Constants.sanctioning_club.AKC, Constants.sanctioning_club.UKC, Constants.sanctioning_club.PWDCA, Constants.sanctioning_club.BHA, Constants.sanctioning_club.ISWS, Constants.sanctioning_club.FH].includes(event.sanctioning_club)) && <div className="btnWrap">
                    <button onClick={() => { setShowArmbandMenu(!showArmbandMenu); }} className="armband" title="Armband Labels">Armband Labels</button>
                    {showArmbandMenu && getArmbandMenu(event.sanctioning_club)}
                  </div>}
                  <div className="btnWrap"><button onClick={() => { toggleDelete() }} className="delete" title="Delete Event">Delete Event</button></div>
                  {event && !event.is_lottery && <div className="btnWrap"><button onClick={() => { 
                    setModalContent("duplicateModal");
                    setTimeout(() => toggle(), 0);
                  }} className="duplicate" title="Duplicate Event">Duplicate Event</button></div>}
                  {event && ([Constants.sanctioning_club.AKC, Constants.sanctioning_club.UKC, Constants.sanctioning_club.PWDCA, Constants.sanctioning_club.BHA, Constants.sanctioning_club.C_WAGS, Constants.sanctioning_club.FH].includes(event.sanctioning_club)) && <div className="btnWrap">
                    <button onClick={() => { setShowMore(!showMore); }} className="more" title="More Options">More</button>
                    {showMore && getAdminMenu(event.sanctioning_club)}
                  </div>}
                </div>}
              </div>
              <div className="headerBottomRow">
                <div className="headerBottomLeft">
                  <div className="clubSection">
                    <div className="clubLogo">
                      {event?.club.logo_url && <img src={event?.club.logo_url} alt={event?.club_name || event?.club.club_name} />}
                      {!event?.club.logo_url && <div className="clubInitial">{(event?.club_name || event?.club.club_name || "?").substring(0, 1)}</div>}
                    </div>
                    <div className="clubInfo">
                      <span className="clubName">{event?.club_name || event?.club.club_name}</span>
                      <span className="clubLink"><Link to={"/k/" + event?.club_id}>Visit Club Page</Link></span>
                    </div>
                  </div>
                  <div className="titleRow">
                    <h1 className="eventTitle">{event?.title}</h1>
                    <span className="sanctioningClub">{event?.sanctioning_club}</span>
                  </div>
                  <div className="subtitleRow">
                  </div>
                </div>
                <div className="headerBottomRight">
                  {isAdmin && <div className="actionButtons">
                    {!!event?.is_lottery && !!event?.lottery_run_date && moment.tz(event?.lottery_run_date, event?.timezone ?? moment.tz.guess()).isSameOrBefore(moment(new Date(), event?.timezone ?? moment.tz.guess()), "day") &&
                        !event?.lottery_ran_at &&
                      <Button className="lotteryRun" isLoading={lotteryShuffleLoading} onClick={() => { setShowRunLotteryConfirm(true); }}>Run Random Draw</Button>
                    }
                    <EventFileUpload
                      event={event as IEventSummary}
                      field="premium_file_url"
                      label="Premium"
                      accept="application/pdf"
                      allowedTypes={["application/pdf"]}
                      maxBytes={1048576 * 15}
                      onUpdated={(updated) => setEvent(updated)}
                    />
                    <EventFileUpload
                      event={event as IEventSummary}
                      field="flyer_image_url"
                      label="Flyer"
                      accept="image/jpeg,image/png,image/webp"
                      allowedTypes={["image/jpeg", "image/png", "image/webp"]}
                      maxBytes={1048576 * 10}
                      onUpdated={(updated) => setEvent(updated)}
                    />
                    <Button onClick={() => { setModalContent("searchUsersModal"); }}>Add Manual Entry</Button>
                  </div>}
                  {!isAdmin && <div className="userActions">
                    <div className="top-buttons">
                      {!!event?.premium_file_url && !isPastEvent && <a href={event.premium_file_url} className="premiumLink" target="_blank" rel="noreferrer">View Premium</a>}
                    </div>
                    {isPastEvent && user.user_type !== "club_manager" && <div className="disabled-register"><span>Event Closed</span></div>}
                    {!isPastEvent && user.user_type !== "club_manager" && (shows && shows.length > 0) && isEventLive() && publishedRegisterButtonLabel(registeredDogs.length)}
                    {!isPastEvent && user.user_type !== "club_manager" && (shows && shows.length > 0) && !isEventLive() && !isVolunteer && <div className="disabled-register"><span>Register</span><div className="hint">This event isn't live yet.</div></div>}
                    {!isPastEvent && user.user_type !== "club_manager" && (shows && shows.length > 0) && !isEventLive() && isVolunteer && volunteerEarlyRegAllowed && publishedRegisterButtonLabel(registeredDogs.length)}
                    {!isPastEvent && user.user_type !== "club_manager" && (shows && shows.length > 0) && !isEventLive() && isVolunteer && !volunteerEarlyRegAllowed && <div className="disabled-register"><span>Register</span><div className="hint">This event isn't live yet.</div></div>}
                    {!isPastEvent && user.user_type !== "club_manager" && (shows && shows.length === 0) && <div className="disabled-register"><span>Register</span><div className="hint">This event doesn't have any shows to register to, yet.</div></div>}
                    {!isPastEvent && user.user_type === "club_manager" && <div className="disabled-register"><span>Register</span><div className="hint">You can't register to an event because you're logged in as a club manager.</div></div>}
                    <button className="shareBtnMobile" onClick={() => { setModalContent("shareModal"); }}>Share</button>
                  </div>}
                </div>
              </div>
            </div>

            {/* Registered Dogs (if user has registered) */}
            {registeredDogs.length > 0 && <div className="registeredDogsRow">
              <ul>
                {registeredDogs.map((dog: IDog, index:number) => {
                  return(<li key={index}><DogPortrait className="smallDogPortrait" showName={false} dog={dog} /></li>);
                })}
                <li className="tag">Registered</li>
              </ul>
            </div>}

            {/* Content Section - Two Column Layout */}
            <div className="contentSection">
              <div className="leftColumn">
                {/* Row 1: Dates and Conditions/Show Types */}
                <div className="infoGrid">
                  <div className="infoColumn">
                    <div className="infoItem">
                      <div className="iconWrap"><img src={date} alt="Starts" /></div>
                      <div className="infoContent">
                        <span className="label">Starts</span>
                        <span className="value">{helperService.setDateInTimezone(event?.timezone, event?.start_date, true)}</span>
                      </div>
                    </div>
                    <div className="infoItem">
                      <div className="iconWrap"><img src={date} alt="Ends" /></div>
                      <div className="infoContent">
                        <span className="label">Ends</span>
                        <span className="value">{helperService.setDateInTimezone(event?.timezone, event?.end_date, true)}</span>
                      </div>
                    </div>
                  </div>
                  <div className="infoColumn">
                    <div className="infoItem">
                      <div className="iconWrap conditionsIcon"></div>
                      <div className="infoContent">
                        <span className="label">Conditions</span>
                        <span className="value">{event?.conditions}</span>
                      </div>
                    </div>
                    <div className="infoItem">
                      <div className="iconWrap trophyIcon"></div>
                      <div className="infoContent">
                        <span className="label">Show Types</span>
                        <div className="showTypesList">
                          {showTypes.map((showType:string, index:number) => {
                            return(<span key={index} className="showTypePill">{showType}</span>);
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Divider */}
                <div className="sectionDivider"></div>

                {/* Row 2: Secretary and Chairperson */}
                <div className="infoGrid contactsGrid">
                  <div className="infoColumn">
                    <div className="infoItem contactItem">
                      <div className="iconWrap secretaryIcon"></div>
                      <div className="infoContent">
                        <span className="label">Secretary</span>
                        <div className="contactNameWrap">
                          <span className="value contactName">{secretary?.first_name} {secretary?.last_name}</span>
                          {secretary?.is_trusted_secretary && (
                            <span className="trustedSecretaryIconBadge" aria-label="Trusted secretary">
                              <img src={pawIcon} alt="Trusted secretary" />
                            </span>
                          )}
                        </div>
                        {secretary?.is_trusted_secretary && (
                          <span className="trustedSecretaryText">Eager Dog Trusted Secretary</span>
                        )}
                        <a href={"tel:" + secretary?.phone} className="contactLink">{secretary?.phone}</a>
                        <a href={"mailto:" + secretary?.email} className="contactLink">{secretary?.email}</a>
                      </div>
                    </div>
                  </div>
                  <div className="infoColumn">
                    <div className="infoItem contactItem">
                      <div className="iconWrap chairpersonIcon"></div>
                      <div className="infoContent">
                        <span className="label">Chairperson</span>
                        <span className="value contactName">{chairperson?.first_name} {chairperson?.last_name}</span>
                        <a href={"tel:" + chairperson?.phone} className="contactLink">{chairperson?.phone}</a>
                        <a href={"mailto:" + chairperson?.email} className="contactLink">{chairperson?.email}</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Column - Location */}
              <div className="rightColumn">
                <div className="locationSection">
                  <div className="infoItem locationAddressBar">
                    <div className="iconWrap locationIcon"></div>
                    <span className="locationAddressText">{getEventAddressLine()}</span>
                  </div>
                  {!!getOpenInMapsUrl() && <a
                    className="openInMapsLink"
                    href={getOpenInMapsUrl()}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Open in Maps
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M14 5h5v5M18.5 5.5L10 14M9 5H6.5A1.5 1.5 0 0 0 5 6.5v11A1.5 1.5 0 0 0 6.5 19h11a1.5 1.5 0 0 0 1.5-1.5V15" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </a>}
                  <EventMapComponent 
                    address={event?.address} 
                    eventTitle={event?.title}
                    hotels={hotels}
                  />
                </div>
              </div>
            </div>
          </div>}
          {loading && <div className="eventDetails skeleton">
            <div className="details big"></div>
            <div className="details half"></div>
            <div className="infoWrap">
              <div className="image">
                <div className="details image"></div>
              </div>
              <div className="info spacer">
                <div className="details"></div>
                <div className="details"></div>
                <div className="details"></div>
                <div className="details spacer half"></div>
                <div className="details half"></div>
                <div className="details half"></div>
                <div className="details spacer"></div>
              </div>
            </div>
          </div>}
          
          {/* Event Summary Section for Past Events (Dog Owners) */}
          {showEventSummary && event && (
            <div className="eventSummary">
              {eventMetrics && (
                <EventMetrics 
                  dogs={eventMetrics.dogs}
                  entries={eventMetrics.entries}
                  distinctBreeds={eventMetrics.distinctBreeds}
                />
              )}
              <ResultsViewer event={event} />
            </div>
          )}

          {/* Show schedule tabs only for non-summary view */}
          {!showEventSummary && <TabContent setTab={setTab} activeTab={activeTab} tabs={tabs} loading={loading}>
          {renderSchedule()}
          {shouldShowRealtimeRunOrder ? renderRealtimeRunOrder() : false}
          {renderHotelsTab()}
          {renderDocumentsTab()}
        </TabContent>}
        </div>
        <Modal
          className={
            modalContent === "noseworkJudgeBooks" ? "noseworkJudgeBooksModal" :
            modalContent === "precisionCoursingJudgeBooks" ? "precisionCoursingJudgeBooksModal" :
            modalContent === "herdingScoresheetsModal" ? "herdingScoresheetsModal" :
            modalContent === "judgeBooksModal" ? "judgeBooksModal" : 
            modalContent === "armbandFilterModal" ? "armbandFilterModal" :
            modalContent === "judgingScheduleFieldsModal" ? "judgingScheduleFieldsModal" :
            modalContent === "catalogShowSelect" ? "catalogShowSelectModal" :
            modalContent === "shareModal" ? "ShareModalContainer" : 
            modalContent === "publishEvent" ? "publishEvent" :
            modalContent === "emailShowRegistrantsModal" && isShowingEmailConfirmation ? "emailConfirmationModal" :
            modalContent === "ribbonSkipModal" || modalContent === "ribbonSkipModalSmall" || modalContent === "scoresheetLabelsModal" ? "ribbonSkipModal" :
            modalContent === "showCounts" || modalContent === "showCountsAKC" ? "countsModal" :
            modalContent === "duplicateModal" ? "duplicateModal" :
            modalContent === "duplicateSuccess" ? "congratsModal" :
            modalContent === "bankPaymentProcessingModal" ? "congratsModal" :
            modalContent
          }
          isShown={isShown}
          hide={toggle}
          modalContent={getModalContent()}
        />
        <Modal className="Confirmation" isShown={isDeleteShown} hide={toggleDelete} modalContent={
          <Confirm
            message={<><p>Are you sure you want to delete this item?</p></>}
            onConfirm={handleArchiveEvent} 
            onCancel={() => toggleDelete()} 
          />
      } />
      <Modal
        className="Confirmation"
        isShown={showResetArmbandConfirm}
        hide={() => { setShowResetArmbandConfirm(false); }}
        modalContent={
          <Confirm
            message={<p>Are you sure you want to reset all armband numbers for this event. This can't be undone.</p>}
            onConfirm={onResetArmbandNumbers}
            onCancel={() => { setShowResetArmbandConfirm(false); }}
          />
        }
      />
      <Modal
        className="Confirmation"
        isShown={showGenerateArmbandConfirm}
        hide={() => { setShowGenerateArmbandConfirm(false); }}
        modalContent={
          <Confirm
            message={
              <div>
                <p>Are you sure you want to generate armband numbers for this event?</p>
                <p><strong>Warning:</strong> Any armband numbers that have already been generated will be reassigned. This cannot be undone.</p>
              </div>
            }
            onConfirm={onGenerateArmbandNumbers}
            onCancel={() => { setShowGenerateArmbandConfirm(false); }}
          />
        }
      />
      <Modal
        className="Confirmation"
        isShown={showRunLotteryConfirm}
        hide={() => { setShowRunLotteryConfirm(false); }}
        modalContent={
          <Confirm
            message={
              <div>
                <p>Are you sure you want to run the Random Draw for this event?</p>
                <p><strong>Warning:</strong> Winners will be selected immediately, notified, and their charges will begin processing. This cannot be undone.</p>
              </div>
            }
            onConfirm={() => { setShowRunLotteryConfirm(false); handleRunLottery(); }}
            onCancel={() => { setShowRunLotteryConfirm(false); }}
          />
        }
      />
      {scheduleBuilderShow && event && (
        <JudgeScheduleBuilder
          event={event}
          show={scheduleBuilderShow}
          onUpdate={() => getEvent(true)}
          onClose={() => setScheduleBuilderShow(undefined)}
        />
      )}

    </div>
  );
}

export default Event;